<div *ngIf="isLoadingVal"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel"> <span i18n="@@">Security Access</span> -
        {{model.name}} {{model.lastName}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>
<div class=m-3>
    <div class="card-body">
        <div class="text-center">
            <div *ngIf="!isLoadingVal">

                <div class="row ">

                    <div class="col-lg-6 mb-3 text-start" (click)="roleListController()">
                        <label for="jobtitle-field" class="form-label" i18n="">Roles</label>
                        <div class="form-control" style="padding: 0%; ">
                            <div class="d-flex align-items -center form-control "
                                style="padding: 0%; border-width: 0px;">
                                <ng-select style="flex-grow: 1; " [items]="rolesList" [multiple]="true" bindLabel="name"
                                    (change)="selectRole(selectedRolesArray)" [(ngModel)]="selectedRolesArray"
                                    placeholder="Roles">
                                    <ng-template ng-optgroup-tmp let-item="item" style="display: flex;">
                                        {{item}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 mb-3 text-start" (click)="accessTypeListController()">
                        <label for="jobtitle-field" class="form-label" i18n="">Access Type</label>
                        <div class="form-control" style="padding: 0%; ">
                            <div class="d-flex align-items-center form-control "
                                style="padding: 0%; border-width: 0px;">
                                <ng-select style="flex-grow: 1; " [multiple]="true" [maxSelectedItems]="1"
                                    bindLabel="name" placeholder="Access Types" [clearSearchOnAdd]="true"
                                    [items]="operationAccessList" [isOpen]="isOperationAccessListOpen"
                                    [(ngModel)]="selectedAccessTypesArray">
                                    <ng-template ng-optgroup-tmp let-item="item" style="display: flex;">
                                        {{item}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-header d-flex" style="margin-bottom: 1rem;">
                    <h4 class="card-title mb-0 flex-grow-1" style="text-align:left;" i18n="@@">Operations</h4>
                </div>
                <div style="max-height: 50vh; overflow: scroll;">
                    <mat-tree [dataSource]="operations" [treeControl]="treeControl" class="example-tree p-1 rounded "
                        style="padding-top: 0.75rem !important; background-color: var(--vz-footer-bg); border: 1px solid  var(--vz-border-color)">
                        <mat-tree-node style="padding-left: 3rem; height: 2rem;" *matTreeNodeDef="let node"
                            matTreeNodeToggle>
                            <input class="form-check-input m-2 fs-14" type="checkbox" value="{{node.isChecked}}"
                                [(ngModel)]="node.isChecked">
                            {{node.description}}
                        </mat-tree-node>
                        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                            <div class="mat-tree-node">
                                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name"
                                    style="height: 2rem;"
                                    [ngClass]="treeControl.isExpanded(node) ? 'bx bx-chevron-down' : 'bx bx-chevron-right'"></button>
                                <input class="form-check-input m-2 fs-14" type="checkbox" value="{{node.isChecked}}"
                                    [(ngModel)]="node.isChecked" (ngModelChange)="setAllChildrenToParentNode(node)">
                                {{node.description}} 
                            </div>
                            <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                                <ng-container matTreeNodeOutlet></ng-container>
                            </div>
                        </mat-nested-tree-node>
                    </mat-tree>
                </div>
            </div>
        </div>
        <div class="hstack justify-content-end pt-3">
            <button type="button" class="btn btn-success" id="add-btn" (click)="submit()" i18n="@@">Update
            </button>
        </div>
    </div>
</div>